const template = `
	<th
		class="s-grid-head"
		:class="classes"
		@click="sortTable"
	>
		<div class="s-grid-head-slot">
			<slot></slot>
		</div>
		<i
			v-if="arrowIcon"
			class="s-grid-head-sort zmdi"
			:class="'zmdi-chevron-' + arrowIcon"
		></i>
	</th>
`;

export default {
	template,
	props: [
		'sort'
	],
	computed: {
		classes() {
			return {
				's-grid-sortable': this.sort != null,
				's-grid-sort-active': !!this.arrowIcon
			};
		},
		absSort() {
			if (!this.sort) return this.sort;
			return this.sort.replace(/^-/, '');
		},
		arrowIcon() {
			let qSort = this.app.query.sort;
			if (!qSort) return;

			if (qSort === this.absSort) return 'up';
			if (qSort.startsWith('-') && qSort.slice(1) === this.absSort) return 'down';
		}
	},
	methods: {
		sortTable() {
			if (this.sort == null) return;

			let sort = this.absSort;
			let isReverse = (this.absSort === this.sort);

			let query;
			let querySort = this.app.query.sort;
			if (querySort && querySort.startsWith('-')) {
				querySort = querySort.substr(1);
			}
			if (sort === querySort) {
				if (!this.app.query.sort.startsWith('-')) {
					sort = '-' + sort;
				}
			} else {
				sort = isReverse ? sort : '-' + sort;
			}
			if (!sort || sort === '-') {
				sort = undefined;
			}
			query = {...this.app.query, sort};

			this.$router.push({query}).catch(err => {
				if (err.name !== 'NavigationDuplicated') throw error;
			});
		}
	}
};